import { takeLatest, all, put, call } from 'redux-saga/effects'

import api from 'Src/api'
import { APP_STATES } from 'Src/constants'
import history from '../history'

import { fetchBots } from './helpers/bots'
import { fetchAccount } from './helpers/account'
import { fetchCurrentUser } from './helpers/users'

import { fetchBotsSuccess } from 'Actions/bots'
import { fetchAccountSuccess } from 'Actions/account'
import { fetchCurrentUserSuccess } from 'Actions/users'
import { UNAUTHORIZED, LOGOUT, FETCH_BASICS, setAppState, logoutSuccess, setCsrfToken } from 'Actions/app'

import meApi from 'Services/me'

export default function* appSaga() {
  yield takeLatest(FETCH_BASICS, onFetchBasics)
  yield takeLatest(UNAUTHORIZED, onUnauthorized)
  yield takeLatest(LOGOUT, onLogout)
}

function* onFetchBasics() {
  try {
    yield put(setAppState({ state: APP_STATES.LOADING }))

    const [currentUser, account, bots] = yield all([fetchCurrentUser(), fetchAccount(), fetchBots()])
    yield put(fetchCurrentUserSuccess(currentUser))
    yield put(fetchAccountSuccess(account))
    yield put(fetchBotsSuccess(bots))
    yield put(setAppState({ state: APP_STATES.SUCCESS }))
  } catch (err) {
    yield put(setAppState({ state: APP_STATES.ERROR }))
    console.error('Error while initializing the app. Fetch basics failed', err)
  }
}

function* onUnauthorized() {
  localStorage.clear()
  history.push({
    pathname: '/login',
    state: { from: history.location }
  })
}

function* onLogout() {
  try {
    yield call(api.post, 'v1/logout')
    yield put(setCsrfToken({ token: null }))
    yield put(meApi.util.invalidateTags(['Me', 'CsrfToken']))
    localStorage.removeItem('auth')
    history.push('/login')
    yield put(logoutSuccess())
  } catch (err) {
    console.error('Unable to logout', err)
  }
}
